import React, { useEffect, useState, useMemo } from 'react';
import { Box, TextField, FormControl, FormGroup, FormControlLabel, Checkbox, Button, Grid, Card, CardContent, Typography, Autocomplete, InputLabel, Select, MenuItem, Paper, Divider, Accordion, AccordionSummary, AccordionDetails, Chip, Alert, Stack } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import SecurityIcon from '@mui/icons-material/Security';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CategoryIcon from '@mui/icons-material/Category';
import LockIcon from '@mui/icons-material/Lock';
import { createUser } from 'User/Domain/Services/CreateUserService';
import { useParams, useNavigate } from 'react-router-dom';
import { patchUser } from 'User/Domain/Services/PatchUserService';
import { getUser } from 'User/Domain/Services/GetUserService';
import { getPermissionsList } from 'Permission/Domain/Services/GetPermissionsListService';
import { toast } from "react-toastify";
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { getPermissionGroupsList } from 'PermissionGroup/Domain/Services/GetPermissionGroupsListService';
import { getCompanyList } from 'Company/Domain/Services/GetCompanyListService';
import { getDelegationList } from 'Delegation/Domain/Services/GetDelegationListService';
import { getJobPositionsList } from 'JobPosition/Domain/Services/GetJobPositionsListService';
import { getProfessionalCategoriesList } from 'ProfessionalCategory/Domain/Services/GetProfessionalCategoriesListService';
import { PRIVATE_ADMIN_LIST_USERS, PRIVATE_USER_LIST_USERS } from '../Constants/PathsConstant';
import { useTranslation } from 'react-i18next';

function FormUserView() {
  const { t } = useTranslation();
  const { isAdmin } = useAuthContext();
  const { id } = useParams();
  const navigate = useNavigate();

  // Security variables
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordTwo, setPasswordTwo] = useState('');
  const [role, setRole] = useState('ROLE_USER');
  const [enabled, setEnabled] = useState(true);

  // Lists
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [inheritedPermissions, setInheritedPermissions] = useState([]);
  const [getPermissions, setGetPermissions] = useState(true);

  const [permissionGroups, setPermissionGroups] = useState([]);
  const [selectedPermissionGroups, setSelectedPermissionGroups] = useState([]);
  const [getPermissionGroups, setGetPermissionGroups] = useState(true);

  const [companies, setCompanies] = useState([]);
  const [delegations, setDelegations] = useState([]);
  const [jobPositions, setJobPositions] = useState([]);
  const [professionalCategories, setProfessionalCategories] = useState([]);
  const [getSelectData, setGetSelectData] = useState(true);

  const [sendingApiRequest, setSendingApiRequest] = useState(false);

  // New variables
  const [name, setName] = useState('');
  const [firstSurname, setFirstSurname] = useState('');
  const [secondSurname, setSecondSurname] = useState('');
  const [dni, setDni] = useState('');
  const [gender, setGender] = useState('');
  const [personalPhone, setPersonalPhone] = useState('');
  const [workPhone, setWorkPhone] = useState('');
  const [extension, setExtension] = useState('');
  const [shortName, setShortName] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [delegationId, setDelegationId] = useState('');
  const [jobPositionId, setJobPositionId] = useState('');
  const [professionalCategoryId, setProfessionalCategoryId] = useState('');
  const [workerId, setWorkerId] = useState('');
  const [iban, setIban] = useState('');
  const [isDirectEmployee, setIsDirectEmployee] = useState(false);
  const [hireDate, setHireDate] = useState('');
  const [terminationDate, setTerminationDate] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [commissionsCommercialExtras, setCommissionsCommercialExtras] = useState(false);
  const [commissionsAnnexes, setCommissionsAnnexes] = useState(false);

  useEffect(() => {
    if (id !== "new") {
      setSendingApiRequest(true);
      getUser(id).then((response) => {
        console.log(response);
        setEmail(response.email || '');
        setRole((response.roles && response.roles.length > 0) ? response.roles[0] : 'ROLE_USER');
        setEnabled(typeof response.enabled === 'boolean' ? response.enabled : true);
        
        setName(response.name || '');
        setFirstSurname(response.firstSurname || '');
        setSecondSurname(response.secondSurname || '');
        setDni(response.dni || '');
        setGender(response.gender || '');
        setPersonalPhone(response.personalPhone || '');
        setWorkPhone(response.workPhone || '');
        setExtension(response.extension || '');
        setShortName(response.shortName || '');
        setCompanyId(response.company ? response.company.id : '');
        setDelegationId(response.delegation ? response.delegation.id : '');
        setJobPositionId(response.jobPosition ? response.jobPosition.id : '');
        setProfessionalCategoryId(response.professionalCategory ? response.professionalCategory.id : '');
        setWorkerId(response.workerId || '');
        setIban(response.iban || '');
        setIsDirectEmployee(response.isDirectEmployee || false);
        setHireDate(response.hireDate ? response.hireDate.split('T')[0] : '');
        setTerminationDate(response.terminationDate ? response.terminationDate.split('T')[0] : '');
        setBirthDate(response.birthDate ? response.birthDate.split('T')[0] : '');
        setCommissionsCommercialExtras(response.commissionsCommercialExtras || false);
        setCommissionsAnnexes(response.commissionsAnnexes || false);

        if (Array.isArray(response.permissions) && response.permissions.length > 0) {
          var perms = [];
          response.permissions.forEach((permission) => {
            if (permission && permission.sku) perms.push(permission.sku);
          });
          setSelectedPermissions(perms);
        }
        if (Array.isArray(response.permissionGroups) && response.permissionGroups.length > 0) {
          var permGroups = [];
          response.permissionGroups.forEach((permissionGroup) => {
            if (permissionGroup && permissionGroup.sku) permGroups.push(permissionGroup.sku);
          });
          setSelectedPermissionGroups(permGroups);
        }
        if (Array.isArray(response.inheritedPermissions)) {
          setInheritedPermissions(response.inheritedPermissions);
        }
        setSendingApiRequest(false);
      });
    }
  }, [id]);

  useEffect(() => {
    if (getPermissions) {
      getPermissionsList({ limit: 1000 }).then((response) => {
        setPermissions(response.records || []);
        setGetPermissions(false);
      });
    }
    if (getPermissionGroups) {
      getPermissionGroupsList().then((response) => {
        setPermissionGroups(response.records);
        setGetPermissionGroups(false);
      });
    }
    if (getSelectData) {
      Promise.all([
        getCompanyList(),
        getDelegationList({limit: 9999}),
        getJobPositionsList({limit: 9999}),
        getProfessionalCategoriesList({limit: 9999})
      ]).then(([compRes, delRes, jobRes, profRes]) => {
        if(compRes) setCompanies(compRes.records);
        if(delRes) setDelegations(delRes.records);
        if(jobRes) setJobPositions(jobRes.records);
        if(profRes) setProfessionalCategories(profRes.records);
        setGetSelectData(false);
      });
    }
  }, [getPermissions, getPermissionGroups, getSelectData]);

  const handlePermissionChange = (event) => {
    const value = event.target.value;
    const currentIndex = selectedPermissions.indexOf(value);
    const newSelectedPermissions = [...selectedPermissions];
    if (currentIndex === -1) {
      newSelectedPermissions.push(value);
    } else {
      newSelectedPermissions.splice(currentIndex, 1);
    }
    setSelectedPermissions(newSelectedPermissions);
  };
  
  const handlePermissionGroupChange = (event) => {
    const value = event.target.value;
    const currentIndex = selectedPermissionGroups.indexOf(value);
    const newSelectedPermissionGroups = [...selectedPermissionGroups];
    if (currentIndex === -1) {
      newSelectedPermissionGroups.push(value);
    } else {
      newSelectedPermissionGroups.splice(currentIndex, 1);
    }
    setSelectedPermissionGroups(newSelectedPermissionGroups);
  };

  const currentJobPosition = useMemo(() => {
    return jobPositions.find((jp) => String(jp.id) === String(jobPositionId)) || null;
  }, [jobPositions, jobPositionId]);

  const inheritedSkus = useMemo(() => {
    return (inheritedPermissions || []).map((p) => p.sku).filter(Boolean);
  }, [inheritedPermissions]);

  const permissionsByCategory = useMemo(() => {
    const grouped = {};
    permissions.forEach((perm) => {
      const cat = perm.category || 'GENERAL';
      if (!grouped[cat]) {
        grouped[cat] = [];
      }
      grouped[cat].push(perm);
    });
    return grouped;
  }, [permissions]);

  const handleToggleCategory = (catPermissions) => {
    const catSkus = catPermissions.map((p) => p.sku).filter((sku) => !inheritedSkus.includes(sku));
    const allSelected = catSkus.length > 0 && catSkus.every((s) => selectedPermissions.includes(s));
    if (allSelected) {
      setSelectedPermissions(selectedPermissions.filter((s) => !catSkus.includes(s)));
    } else {
      const toAdd = catSkus.filter((s) => !selectedPermissions.includes(s));
      setSelectedPermissions([...selectedPermissions, ...toAdd]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      var apiResponse = null;
      if (password !== passwordTwo) {
        toast.error("Las contraseñas no coinciden");
        return;
      }
      if (sendingApiRequest) return;
      setSendingApiRequest(true);

      const payload = {
        email,
        roles: [role],
        enabled,
        permissions: selectedPermissions,
        permissionGroups: selectedPermissionGroups,
        name,
        firstSurname,
        secondSurname,
        dni,
        gender,
        personalPhone,
        workPhone,
        extension,
        shortName,
        companyId: companyId || null,
        delegationId: delegationId || null,
        jobPositionId: jobPositionId || null,
        professionalCategoryId: professionalCategoryId || null,
        workerId,
        iban,
        isDirectEmployee,
        hireDate: hireDate || null,
        terminationDate: terminationDate || null,
        birthDate: birthDate || null,
        commissionsCommercialExtras,
        commissionsAnnexes
      };

      if (id === "new") {
        apiResponse = await createUser({
          ...payload,
          password: password,
        });
      } else {
        apiResponse = await patchUser(id, {
          ...payload,
          password: password ? password : null,
        });
      }
      
      setSendingApiRequest(false);
      if (apiResponse !== null) {
        if (isAdmin()) {
          navigate(PRIVATE_ADMIN_LIST_USERS);
        } else {
          navigate(PRIVATE_USER_LIST_USERS);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box sx={{ width: '100%', p: { xs: 2, md: 4 }, backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, maxWidth: 1200, mx: 'auto', backgroundColor: '#ffffff' }}>
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 'bold', color: '#1a237e', textAlign: 'center' }}>
          {id === "new" ? t('user.form.create') : t('user.form.update')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 5, color: '#607d8b', textAlign: 'center' }}>
          {id === "new" ? 'Rellena los campos a continuación para crear un nuevo usuario en el sistema.' : 'Modifica la información del usuario en las siguientes secciones.'}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            
            {/* Datos Personales */}
            <Grid item xs={12} md={6}>
              <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, border: 'none', boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <PersonIcon sx={{ color: '#1976d2', mr: 1, fontSize: 28 }} />
                    <Typography variant="h6" fontWeight="bold" color="#333">{t('user.form.section.personal')}</Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.name')} value={name} onChange={(e) => setName(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.firstSurname')} value={firstSurname} onChange={(e) => setFirstSurname(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.secondSurname')} value={secondSurname} onChange={(e) => setSecondSurname(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.dni')} value={dni} onChange={(e) => setDni(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.gender')} value={gender} onChange={(e) => setGender(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="date" InputLabelProps={{ shrink: true }} label={t('user.form.birthDate')} value={birthDate} onChange={(e) => setBirthDate(e.target.value)} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

            {/* Datos de Contacto */}
            <Grid item xs={12} md={6}>
              <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, border: 'none', boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <ContactPhoneIcon sx={{ color: '#2e7d32', mr: 1, fontSize: 28 }} />
                    <Typography variant="h6" fontWeight="bold" color="#333">{t('user.form.section.contact')}</Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField fullWidth required label={t('user.form.email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth label={t('user.form.phone')} value={personalPhone} onChange={(e) => setPersonalPhone(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth label={t('user.form.workPhone')} value={workPhone} onChange={(e) => setWorkPhone(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField fullWidth label={t('user.form.extension')} value={extension} onChange={(e) => setExtension(e.target.value)} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label={t('user.form.shortName')} value={shortName} onChange={(e) => setShortName(e.target.value)} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

            {/* Datos de Empresa */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, border: 'none', boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <BusinessIcon sx={{ color: '#ed6c02', mr: 1, fontSize: 28 }} />
                    <Typography variant="h6" fontWeight="bold" color="#333">{t('user.form.section.company')}</Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={companies}
                      getOptionLabel={(option) => option.name || ''}
                      value={companies.find(c => c.id === companyId) || null}
                      onChange={(event, newValue) => setCompanyId(newValue ? newValue.id : '')}
                      renderInput={(params) => <TextField {...params} label={t('user.form.company')} variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={delegations}
                      getOptionLabel={(option) => option.name || ''}
                      value={delegations.find(d => d.id === delegationId) || null}
                      onChange={(event, newValue) => setDelegationId(newValue ? newValue.id : '')}
                      renderInput={(params) => <TextField {...params} label={t('user.form.delegation')} variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={jobPositions}
                      getOptionLabel={(option) => option.name || ''}
                      value={jobPositions.find(j => j.id === jobPositionId) || null}
                      onChange={(event, newValue) => setJobPositionId(newValue ? newValue.id : '')}
                      renderInput={(params) => <TextField {...params} label={t('user.form.jobPosition')} variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={professionalCategories}
                      getOptionLabel={(option) => option.name || ''}
                      value={professionalCategories.find(p => p.id === professionalCategoryId) || null}
                      onChange={(event, newValue) => setProfessionalCategoryId(newValue ? newValue.id : '')}
                      renderInput={(params) => <TextField {...params} label={t('user.form.professionalCategory')} variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.workerId')} value={workerId} onChange={(e) => setWorkerId(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label={t('user.form.iban')} value={iban} onChange={(e) => setIban(e.target.value)} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

            {/* Configuración Laboral */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, border: 'none', boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <WorkOutlineIcon sx={{ color: '#9c27b0', mr: 1, fontSize: 28 }} />
                    <Typography variant="h6" fontWeight="bold" color="#333">{t('user.form.section.labor')}</Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="date" InputLabelProps={{ shrink: true }} label={t('user.form.hireDate')} value={hireDate} onChange={(e) => setHireDate(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="date" InputLabelProps={{ shrink: true }} label={t('user.form.terminationDate')} value={terminationDate} onChange={(e) => setTerminationDate(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel control={<Checkbox checked={isDirectEmployee} onChange={(e) => setIsDirectEmployee(e.target.checked)} />} label={t('user.form.isDirectEmployee')} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel control={<Checkbox checked={commissionsCommercialExtras} onChange={(e) => setCommissionsCommercialExtras(e.target.checked)} />} label={t('user.form.commissionsExtras')} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel control={<Checkbox checked={commissionsAnnexes} onChange={(e) => setCommissionsAnnexes(e.target.checked)} />} label={t('user.form.commissionsAnnexes')} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

            {/* Seguridad y Accesos */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, border: 'none', boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <SecurityIcon sx={{ color: '#d32f2f', mr: 1, fontSize: 28 }} />
                    <Typography variant="h6" fontWeight="bold" color="#333">{t('user.form.section.security')}</Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth {...(id === "new" ? { required: true } : {})} label={t('user.form.password')} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth {...(id === "new" ? { required: true } : {})} label={t('user.form.password_two')} type="password" value={passwordTwo} onChange={(e) => setPasswordTwo(e.target.value)} />
                  </Grid>
                  {isAdmin() && (
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel>{t('user.form.role')}</InputLabel>
                        <Select label={t('user.form.role')} value={role} onChange={(e) => setRole(e.target.value)}>
                          <MenuItem value="ROLE_USER">{t('user.form.role_user')}</MenuItem>
                          <MenuItem value="ROLE_ADMIN">{t('user.form.role_admin')}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel control={<Checkbox checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />} label={t('user.form.enabled')} />
                  </Grid>
                </Grid>

                {/* Información de permisos por Puesto de Trabajo */}
                <Box sx={{ mt: 3, mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <WorkOutlineIcon color="primary" fontSize="small" />
                    Permisos por Puesto de Trabajo
                  </Typography>
                  {currentJobPosition ? (
                    currentJobPosition.permissionGroup ? (
                      <Alert severity="info" sx={{ borderRadius: 2 }}>
                        <strong>Puesto:</strong> {currentJobPosition.name} &nbsp;|&nbsp; 
                        <strong> Grupo de permisos asignado:</strong> {currentJobPosition.permissionGroup.description || currentJobPosition.permissionGroup.sku}
                        <br />
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          Este usuario recibe automáticamente todos los permisos asociados a este grupo según su puesto.
                        </Typography>
                        {inheritedPermissions.length > 0 && (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8, mt: 1.5 }}>
                            {inheritedPermissions.map((ip) => (
                              <Chip
                                key={ip.sku}
                                size="small"
                                label={`${ip.description || ip.sku} (${ip.category || 'GENERAL'})`}
                                color="info"
                                variant="filled"
                                icon={<LockIcon />}
                              />
                            ))}
                          </Box>
                        )}
                      </Alert>
                    ) : (
                      <Alert severity="warning" sx={{ borderRadius: 2 }}>
                        El puesto asignado (<strong>{currentJobPosition.name}</strong>) no tiene ningún grupo de permisos configurado en la sección de administración de puestos.
                      </Alert>
                    )
                  ) : (
                    <Alert severity="info" sx={{ borderRadius: 2 }}>
                      Selecciona un puesto de trabajo arriba en los datos laborales para asignar automáticamente su grupo de permisos.
                    </Alert>
                  )}
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* Permisos Ad-hoc (Específicos del Usuario) */}
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <SecurityIcon color="primary" fontSize="small" />
                      Permisos Ad-hoc (Específicos del Usuario)
                    </Typography>
                    <Chip
                      size="small"
                      label={`${selectedPermissions.length} permisos ad-hoc concedidos`}
                      color="primary"
                      variant="outlined"
                    />
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Puedes asignar permisos adicionales de forma individual a este usuario. Se organizan por categoría para facilitar su búsqueda.
                  </Typography>

                  {Object.keys(permissionsByCategory).length === 0 ? (
                    <Typography variant="body2">{t('user.form.no_permissions')}</Typography>
                  ) : (
                    Object.keys(permissionsByCategory).map((catName) => {
                      const catPerms = permissionsByCategory[catName];
                      const nonInheritedPerms = catPerms.filter((p) => !inheritedSkus.includes(p.sku));
                      const selectedCount = nonInheritedPerms.filter((p) => selectedPermissions.includes(p.sku)).length;
                      const allSelected = nonInheritedPerms.length > 0 && selectedCount === nonInheritedPerms.length;

                      return (
                        <Accordion key={catName} defaultExpanded sx={{ mb: 1.5, border: '1px solid #e0e0e0', boxShadow: 'none', '&:before': { display: 'none' }, borderRadius: '8px !important' }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 2 }}>
                              <Stack direction="row" spacing={1.5} alignItems="center">
                                <CategoryIcon color="primary" fontSize="small" />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                  {catName}
                                </Typography>
                                <Chip
                                  size="small"
                                  label={`${selectedCount} / ${nonInheritedPerms.length} ad-hoc`}
                                  color={selectedCount > 0 ? 'primary' : 'default'}
                                  variant={selectedCount > 0 ? 'filled' : 'outlined'}
                                />
                              </Stack>
                              {nonInheritedPerms.length > 0 && (
                                <Button
                                  size="small"
                                  variant="text"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleCategory(catPerms);
                                  }}
                                  sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                                >
                                  {allSelected ? 'Desmarcar categoría' : 'Marcar categoría'}
                                </Button>
                              )}
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails sx={{ pt: 0, pb: 1.5, px: 3, bgcolor: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                            {catPerms.map((p) => {
                              const isInherited = inheritedSkus.includes(p.sku);
                              return (
                                <FormGroup key={p.sku}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={isInherited || selectedPermissions.includes(p.sku)}
                                        onChange={handlePermissionChange}
                                        value={p.sku}
                                        disabled={isInherited}
                                      />
                                    }
                                    label={
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.3 }}>
                                        <span>{p.description}</span>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', bgcolor: '#eee', px: 0.8, py: 0.2, borderRadius: 1 }}>
                                          {p.sku}
                                        </Typography>
                                        {isInherited && (
                                          <Chip
                                            size="small"
                                            label="Heredado del puesto"
                                            color="info"
                                            variant="outlined"
                                            sx={{ fontSize: '0.7rem', height: 20 }}
                                          />
                                        )}
                                      </Box>
                                    }
                                  />
                                </FormGroup>
                              );
                            })}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  )}
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* Grupos de Permisos Adicionales */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    {t('user.form.permission_groups')} (Adicionales)
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Puedes asignar grupos de permisos adicionales directamente a este usuario además de los del puesto.
                  </Typography>
                  {permissionGroups.length === 0 ? (
                    <Typography variant="body2">{t('user.form.no_permission_groups')}</Typography>
                  ) : (
                    <Grid container spacing={1}>
                      {permissionGroups.map((pg) => (
                        <Grid item xs={12} sm={6} key={pg.id}>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked={selectedPermissionGroups.includes(pg.sku)} onChange={handlePermissionGroupChange} value={pg.sku} />}
                              label={
                                <Box>
                                  <Typography variant="body2" fontWeight="500">{pg.description}</Typography>
                                  <Typography variant="caption" color="text.secondary">{pg.sku}</Typography>
                                </Box>
                              }
                            />
                          </FormGroup>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>

              </CardContent>
            </Card>
          </Grid>

            {/* Botones */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                <Button variant="outlined" color="inherit" size="large" onClick={() => navigate(isAdmin() ? PRIVATE_ADMIN_LIST_USERS : PRIVATE_USER_LIST_USERS)} sx={{ borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', fontWeight: 'bold' }}>
                  {t('user.form.cancel')}
                </Button>
                <Button variant="contained" color="primary" type="submit" size="large" sx={{ borderRadius: 2, px: 4, py: 1.5, textTransform: 'none', fontWeight: 'bold', boxShadow: '0 4px 12px 0 rgba(25, 118, 210, 0.3)' }}>
                  {id === "new" ? t('user.form.create') : t('user.form.update')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
      <DialogLoader open={sendingApiRequest} />
    </Box>
  );
}

export default FormUserView;
